export default __webpack_public_path__ + "static/media/master-card.a7f09894.svg";